import { Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';

import { Country } from '@mp/organization-master-data/countries/domain';

import { CountriesActions } from './countries.actions';
import { selectCountries, selectCountriesLoaded } from './countries.selectors';

@Injectable()
export class CountriesFacade {
  readonly countries: Signal<Country[]> = this.store$.selectSignal(selectCountries);

  readonly countriesLoaded: Signal<boolean> = this.store$.selectSignal(selectCountriesLoaded);

  constructor(private readonly store$: Store) {}

  fetchCountries(): void {
    this.store$.dispatch(CountriesActions.fetchCountries());
  }
}
